import SavingIndicator from "@/components/savingIndicator.component";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import type React from "react";

interface KlausurErstellerTopBarProps {
	klausurTitle: string;
	handleBackToDashboard: () => void;
}

/*
 * KlausurErstellerTopBar
 *
 * This component is used to display the top bar of the klausur ersteller page.
 * It contains the title of the klausur, a preview button and a saving indicator.
 */
export const KlausurErstellerTopBar: React.FC<KlausurErstellerTopBarProps> = ({
	klausurTitle,
	handleBackToDashboard,
}) => {
	return (
		<div className="h-16 border-b flex items-center justify-between px-4 space-x-4 mx-auto w-full">
			<div className="flex items-center space-x-2 w-full">
				<Button
					variant="ghost"
					size="icon"
					onClick={handleBackToDashboard}
					aria-label="Zurück zum Dashboard"
				>
					<ArrowLeft className="h-5 w-5" />
				</Button>
				<p>{klausurTitle}</p>
				<div className="ml-auto">
					<SavingIndicator />
				</div>
			</div>
		</div>
	);
};
